import { createContext } from 'react';

import type { AuthorLevelId } from '@/features/original-plus/constants';

export type { AuthorLevelId };

export type AuthorLevelsApplicationContextValue = {
  selectedLevelId: AuthorLevelId;
  setSelectedLevelId: (id: AuthorLevelId) => void;
  wantsConsultation: boolean;
  setWantsConsultation: (value: boolean) => void;
  applyForLevel: (id: AuthorLevelId) => void;
};

export const AuthorLevelsApplicationContext =
  createContext<AuthorLevelsApplicationContextValue | null>(null);
